import { css } from "@emotion/react";
import { ThemedCssCreator } from "../../../../../config/emotion";

export const containerCss = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  min-width: 270px;
`;

export const acceptButtonCss: ThemedCssCreator = (theme) => css`
  background-color: ${theme.colors.save};
  color: white;
`;

export const declineButtonCss: ThemedCssCreator = (theme) => css`
  background-color: ${theme.colors.delete};
  color: white;
`;
